import { render, staticRenderFns } from "./HeaderIcon.vue?vue&type=template&id=e501415c&scoped=true"
import script from "./HeaderIcon.vue?vue&type=script&lang=js"
export * from "./HeaderIcon.vue?vue&type=script&lang=js"
import style0 from "./HeaderIcon.vue?vue&type=style&index=0&id=e501415c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e501415c",
  null
  
)

export default component.exports